/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import getCartLineError from '../../helpers/get-cart-line-error'
import combineClassNames from '../../helpers/combineClassNames'
import parseStockLevel from '../../helpers/parse-stock-level'
import SkuQuotaService from '../../services/sku-quota-service'
import { useAlert } from '../../hook/use-alert'
import useCurrencies from '../../hook/use-currencies'
import { useThemeConfig } from '../../hook/use-theme-config'
import { useProductQuickAddModal } from '../../hook/use-product-quick-add-modal'
// import CartLineVariant from '../cart-line-variant'
import CartLineItemPlaceholder from './cart-line-item-placeholder-view'
import CartLineAddons from '../cart-line-addons'
import ClassStateLabel from '../class-state-label'
// import Button from '../button'
// import Dropdown from '../dropdown'
import CurrencyFormat from '../currency-format'
import Link from '../link'
import Image from '../image'
import InputQuantity from '../input-quantity'
// import {
//   customStylesOnlyText,
// } from '../dropdown/custom-styles'
// import clearIcon from '../../assets/icons/icon_clear_grey.svg'
import useStyles from './cart-line-item-style'
import Button from '../button'
import IconCrossBold from '../../assets/icons/icon_cross_bold.inline.svg'

const LinkToProduct = ({
  to,
  disabled = false,
  gatsbyLink,
  ...otherProps
}) => {
  if (
    _.isEmpty(to)
    || disabled
  ) {
    return (
      <span {...otherProps} />
    )
  }
  return (
    <Link
      gatsbyLink={gatsbyLink}
      to={to}
      {...otherProps}
    />
  )
}

const CartLineItemView = ({
  cartLine = {},
  cartMaxNumOfQtyPerSku,
  currency: _currency,
  currencyCode,
  errors,
  // disableNavigation,
  enableLinkToProduct = true,
  loading,
  maxSelectableQty,
  onEdit,
  onEditCompleted,
  // onRemove,
  onAddToWaitlist = () => {},
  onUpdateQuantity = () => {},
  placeholder = false,
  readOnly,

  // classNames
  className,
  thumbnailClassName,
  thumbnailImageClassName,
  titleClassName,
} = {}) => {
  // prepare hook
  const alert = useAlert()
  const { getCurrency } = useCurrencies()
  const { t } = useTranslation()
  const { getConfig } = useThemeConfig()
  const {
    open: openProductQuickAddModal,
  } = useProductQuickAddModal()

  // local variable
  const enableQuickAddItem = getConfig('config.enableQuickAddItem', false)
  const currency = getCurrency(currencyCode, _currency)
  const {
    title,
    id,
    addons = [],
    groupUuid,
    inlineError,
    priceDetails = {},
    quantity,
    sku = {},
    skuQuota = {},
    skuIsInactive,
    skuQuotaWaitingList = false,
  } = cartLine
  const {
    colorOption: colorOptionInsideSku = {},
    product: productInsideSku = {},
    sizeOption: sizeOptionInsideSku = {},
  } = sku
  const {
    mainPropertyUnitPrice,
    mainPropertyDiscountGroup,
    mainPropertySubtotalPrice,
  } = priceDetails
  const stockLevel = parseStockLevel(_.get(sku, 'stockLevel'))
  // resolve data from different endpoint
  const product = _.get(cartLine, 'product', productInsideSku)
  const colorOption = _.get(cartLine, 'colorOption', colorOptionInsideSku)
  const sizeOption = _.get(cartLine, 'sizeOption', sizeOptionInsideSku)

  const cartLineImage = _.get(colorOption, 'defaultImage.versions.webSmallThumb')

  // check and get error message
  const errorMessage = getCartLineError({
    cartMaxNumOfQtyPerSku,
    maxSelectableQty,
    quantity,
    skuIsInactive,
    stockLevel,
  })
  const isError = !_.isEmpty(errorMessage)

  // function
  const resolveUpdateCartLineAction = (line) => _.omitBy({
    id: _.get(line, 'id'),
    skuId: _.get(line, 'sku.id'),
    productAddonId: _.get(line, 'productAddon.id', null),
    identifierUuid: _.get(line, 'identifierUuid'),
    parentIdentifierUuid: _.get(line, 'parentIdentifierUuid', null),
    groupUuid: _.get(line, 'groupUuid'),
    quantity: _.get(line, 'quantity'),
    skuQuotaId: _.get(line, 'skuQuota.id'),
    skuQuotaProfileId: _.get(line, 'sku.skuQuotaProfileId'),
    skuQuotaWaitingList: _.get(line, 'skuQuotaWaitingList'),
    // customerRemark: _.get(line, 'id'),
    // skuMeasure: _.get(line, 'id'),
    // skuMeasureId: _.get(line, 'id'),
  }, _.isUndefined)

  const handleQuantityChange = (value) => {
    if (value === quantity) return
    onUpdateQuantity({
      ...resolveUpdateCartLineAction(cartLine),
      quantity: _.max([value, 0]),
    })
  }

  const handleMoveToWaitlist = _.debounce(
    () => {
      onAddToWaitlist({
        ...resolveUpdateCartLineAction(cartLine),
        skuQuotaWaitingList: true,
      })
    },
    1000,
    { leading: true, trailing: false },
  )

  const handleEdit = () => {
    if (_.isFunction(onEdit)) {
      onEdit(cartLine)
    }
    openProductQuickAddModal({
      id: _.get(product, 'id'),
      colorOptionId: _.get(colorOption, 'id'),
      groupUuid,
      onAddToCartSuccess: () => {
        if (_.isFunction(onEditCompleted)) onEditCompleted()
        alert.show(
          t('screens.products.alertMessage', { context: 'addItemToCartSuccess' }),
          { state: 'default', autoClose: 1000 },
        )
      },
    })
  }

  const name = _.get(skuQuota, 'name') || _.get(product, 'title') || title || ''
  const displayName = _.join(_.compact([
    name,
    _.get(product, 'brands.0.name'),
  ]), ' | ')
  // variant
  // `product.hideVariants` is for legacy order items
  const productHideVariants = _.get(product, 'hideVariants', [])
  const colorOptionName = _.get(colorOption, 'name')
  const sizeOptionName = _.get(sizeOption, 'name')
  const colorOptionVariantType = _.get(product, 'colorOptionVariantType')
  const sizeOptionVariantType = _.get(product, 'sizeOptionVariantType')
  const variants = []
  if (
    !_.get(sizeOptionVariantType, 'hideVariant', false)
    && !_.includes(productHideVariants, 'size_option')
  ) {
    variants.push(sizeOptionName)
  }
  if (
    !_.get(colorOptionVariantType, 'hideVariant', false)
    && !_.includes(productHideVariants, 'color_option')
  ) {
    variants.push(colorOptionName)
  }
  const variantDescription = _.compact(variants).join(' / ')

  // Sku quota info
  const canWaitingList = _.get(skuQuota, 'canWaitingList', false)
  const skuQuotaSalesperson = _.get(skuQuota, 'salesperson.alias') || _.get(skuQuota, 'salesperson.name')
  const skuQuotaStore = _.get(skuQuota, 'store.name')
  const fromTime = _.get(skuQuota, 'fromTimeTimestamp')
  const toTime = _.get(skuQuota, 'toTimeTimestamp')
  const skuQuotaInfo = []
  if (skuQuotaSalesperson) {
    skuQuotaInfo.push({
      key: 'salesperson',
      value: t(
        'screens.classes.item.teacher',
        { name: skuQuotaSalesperson },
      ),
    })
  }
  if (skuQuotaStore) {
    skuQuotaInfo.push({
      key: 'store',
      value: t(
        'screens.classes.item.store',
        { store: _.get(skuQuota, 'store.name') },
      ),
    })
  }
  if (fromTime && toTime) {
    const skuQuoteTime = SkuQuotaService.getClassDisplayTime({
      date: _.get(skuQuota, 'date'),
      fromTime,
      toTime,
    })
    skuQuotaInfo.push({
      key: 'time',
      value: skuQuoteTime,
    })
  }

  const stateLabels = []
  if (_.includes(_.map(errors, 'code'), 'skuQuotaNotEnoughQuota')) {
    stateLabels.push('full')
  }
  if (skuQuotaWaitingList) {
    stateLabels.push('waitlist')
  }

  const errorRequireRemove = _.size(
    _.filter(errors, (error) => (
      _.includes(
        [
          'outOfStock',
          'notAvailable',
          'invalidSkuQuota',
          'invalidSkuQuotaProfile',
          'notSupportedSkuQuota',
          'userCannotUseLoyaltyPoints',
          'skuQuotaNotAvailable',
          'skuQuotaInvalidConsumePeriod',
          'inactiveSku',
          'skuNotFound',
        ],
        _.get(error, 'code'),
      )
    )),
  ) > 0

  // links
  const productLink = `/product/${_.get(product, 'id')}?color=${_.get(colorOption, 'id')}`
  const editLink = `/product/${_.get(product, 'id')}?groupUuid=${groupUuid}&colorOptionId=${_.get(colorOption, 'id')}&sizeOptionId=${_.get(sizeOption, 'id')}`
  // style
  const styles = useStyles({ isError })

  if (placeholder) {
    return <CartLineItemPlaceholder />
  }

  return (
    <div
      className={combineClassNames([
        styles.row,
        styles.container,
        className,
      ])}
    >
      <div
        className={
          combineClassNames([
            styles.thumbnail,
            thumbnailClassName,
          ])
        }
      >
        <LinkToProduct
          to={productLink}
          disabled={!enableLinkToProduct}
          gatsbyLink
        >
          <Image
            className={combineClassNames([
              styles.thumbnailImage,
              thumbnailImageClassName,
            ])}
            placeholderClassName={styles.thumbnailImagePlaceholder}
            src={cartLineImage}
          />
        </LinkToProduct>
      </div>
      <div
        className={combineClassNames([
          styles.body,
        ])}
      >
        <div
          className={combineClassNames([
            styles.row,
            styles.contentContainer,
          ])}
        >
          <div
            className={combineClassNames([
              styles.column,
              styles.content,
            ])}
          >
            <div
              className={combineClassNames([
                styles.info,
              ])}
            >
              {
                !_.isEmpty(stateLabels) && (
                  <div
                    className={combineClassNames([
                      styles.classStateLabels,
                    ])}
                  >
                    {
                      _.map(stateLabels, (stateLabel) => (
                        <ClassStateLabel
                          key={stateLabel}
                          state={stateLabel}
                        />
                      ))
                    }
                  </div>
                )
              }
              <div
                className={combineClassNames([
                  styles.row,
                  styles.titleContainer,
                ])}
              >
                <p
                  className={combineClassNames([
                    styles.title,
                    titleClassName,
                  ])}
                >
                  <LinkToProduct
                    to={productLink}
                    gatsbyLink
                    disabled={!enableLinkToProduct}
                    className={styles.titleLink}
                  >
                    {displayName}
                  </LinkToProduct>
                </p>
                {
                  !readOnly && (
                    <div
                      className={styles.quantity}
                    >
                      <InputQuantity
                        value={quantity}
                        onChange={handleQuantityChange}
                        max={errorRequireRemove ? 0 : maxSelectableQty}
                        min={0}
                        step={1}
                        inline
                        deferedValueUpdate
                        loading={loading}
                      />
                    </div>
                  )
                }
              </div>
              {
                !_.isEmpty(variantDescription) && (
                  <p className={styles.variant}>
                    {variantDescription}
                  </p>
                )
              }
              {
                !_.isEmpty(skuQuotaInfo) && (
                  <p
                    className={styles.skuQuotaInfo}
                    dangerouslySetInnerHTML={{
                      __html: _.join(_.map(skuQuotaInfo, 'value'), '<br />'),
                    }}
                  />
                )
              }
              <CartLineAddons
                addons={addons}
                className={styles.addons}
                currency={currency}
                itemClassName={styles.addonsItem}
              />
              {_.map(mainPropertyDiscountGroup, (discount) => (
                <div
                  className={styles.discounts}
                  key={`discount-line-${discount}`}
                >
                  <p className={styles.variant}>
                    {_.get(discount, 'title', '')}
                  </p>
                  <p className={combineClassNames([styles.variant, styles.variantPrice])}>
                    <CurrencyFormat value={_.get(discount, 'totalAmount', 0)} currency={currency} />
                  </p>
                </div>
              ))}
              {
                !_.isEmpty(addons) && !readOnly && (
                  <p className={styles.actions}>
                    <Link
                      className={styles.actionLink}
                      gatsbyLink={!enableQuickAddItem}
                      to={enableQuickAddItem ? null : editLink}
                      onClick={enableQuickAddItem ? handleEdit : () => (false)}
                    >
                      {t('screens.cart.edit')}
                    </Link>
                  </p>
                )
              }
            </div>
            <div
              className={combineClassNames([
                styles.unitPrice,
              ])}
            >
              <p
                className={combineClassNames([
                  styles.amount,
                  styles.unitPriceAndQuantity,
                ])}
              >
                <CurrencyFormat value={mainPropertyUnitPrice} currency={currency} />
                {` x ${quantity}`}
              </p>
              <CurrencyFormat
                className={combineClassNames([
                  styles.amount,
                  styles.subtotalAmount,
                  styles.subtotalAmountForReadOnly,
                ])}
                currency={currency}
                value={mainPropertySubtotalPrice}
              />
            </div>
          </div>
        </div>
        {
          _.includes(_.map(errors, 'code'), 'skuQuotaNotEnoughQuota')
          && canWaitingList
          && !skuQuotaWaitingList
          && (
            <div
              className={styles.buttons}
            >
              <Button
                border
                className={styles.button}
                onClick={handleMoveToWaitlist}
                text={t('screens.cart.buttons.addToWaitlist')}
              />
            </div>
          )
        }
        {
          (!_.isEmpty(errors) || !_.isEmpty(inlineError))
          && (
            <div
              className={combineClassNames([
                styles.errors,
              ])}
            >
              {/* Error Message */}
              {/* {isError && <p className={styles.errorMessage}>{errorMessage}</p>} */}
              {
                !_.isEmpty(inlineError) && (
                  <p className={styles.errorMessage}>{inlineError}</p>
                )
              }
              {
                _.map(_.uniqBy(errors, 'message'), ({ code, message }) => (
                  <p
                    className={styles.errorMessage}
                    key={`${id}_${code}`}
                  >
                    {message}
                  </p>
                ))
              }
            </div>
          )
        }
        {
          !readOnly && (
            <div>
              <Button
                inline
                iconInline
                iconImage={IconCrossBold}
                className={combineClassNames([styles.button, styles.buttonRemove])}
                iconClassName={combineClassNames([styles.buttonRemoveIcon])}
                onClick={() => handleQuantityChange(0)}
              >
                {t('screens.cart.buttons.remove')}
              </Button>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default CartLineItemView
